import store from '../store';

export function itemSelectorToggle() {
    return { type: 'ITEM_SELECTOR_TOGGLE' };
}

export function itemSelectorOpenCategory(category) {
    return {
        type: 'ITEM_SELECTOR_OPEN_CATEGORY',
        payload: category
    };
}

export function itemSelectorOpenRecents() {
    return {
        type: 'ITEM_SELECTOR_OPEN_RECENTS'
    };
}

export function toggleMoveMode() {
    return {
        type: 'LEVEL_EDITOR_TOGGLE_MOVE'
    };
}

export function toggleBackgroundMode() {
    return {
        type: 'LEVEL_EDITOR_TOGGLE_BACKGROUND'
    };
}

export function setHoveredPrefabName(prefabName) {
    return {
        type: 'LEVEL_EDITOR_PREFAB_HOVER',
        payload: prefabName
    };
}

export function backgroundEditorSetTile(id) {
    return {
        type: 'LEVEL_EDITOR_BG_SET_TILE_ID',
        payload: id
    };
}
